import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/configuracion/catalogos-de-tarifas/';

/**
 * GET Catalogo de Tarifas
 * @returns {Promise<Array<object>>}
 */
export const getCatalogoDeTarifas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo De Tarifa
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCatalogoDeTarifa = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Catalogo De Tarifa
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCatalogoDeTarifa = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Catalogo De Tarifa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCatalogoDeTarifa = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Catalogo De Tarifa
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCatalogoDeTarifa = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
